import { createContext } from "react";

/** Where an AvatarImage is in loading its picture. `idle` = no image. */
export type AvatarImageStatus = "idle" | "loading" | "loaded" | "error";

export interface AvatarContextValue {
  /** The Avatar paints its own fill and text (`seed` or `tone`). */
  readonly painted: boolean;
  readonly imageStatus: AvatarImageStatus;
  readonly onImageStatus: (status: AvatarImageStatus) => void;
}

function ignoreImageStatus(): void {}

/* Outside an Avatar nothing is painted and there is no image, so an
   AvatarFallback keeps its own text-pb-text and always renders. */
export const AvatarContext = createContext<AvatarContextValue>({
  painted: false,
  imageStatus: "idle",
  onImageStatus: ignoreImageStatus,
});
